import {Component, OnInit} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";
import {Order} from "../../../../../../common/interfaces/order.interface";


@Component({
    selector: "section-order-list-type-informative",
    template: `
        <section-order-list [params]="params"></section-order-list>`
})
export class OrderListTypeInformativeComponent implements Base.IComponent, OnInit {

    public readonly state: Base.IState;

    public params: Order.IOrderListParams;

    public constructor() {
    }

    public ngOnInit(): void {
        this.params = {
            title: "Informative orders list",
            state: this.state,
            actions: {
                view: true,
                delete: true,
                add: false,
                export: true,
                remarks: true
            },
            query: {order_type: "informative"}
        };
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "orders-type-informative",
            actions: {
                "browse": ["browse_orders"]
            }
        };
    }

}
